export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M7.703 4c.967 0 1.75.784 1.75 1.75v1H21l.102.005A1 1 0 0 1 22 7.75V19l-.005.102a1 1 0 0 1-.893.893L21 20H3l-.103-.005a1 1 0 0 1-.892-.893L2 19V5.75C2 4.784 2.784 4 3.75 4h3.953ZM3.5 18.5h17V8.25h-17V18.5Zm.25-13a.25.25 0 0 0-.25.25v1h4.453v-1a.25.25 0 0 0-.25-.25H3.75Z"/>
</svg>
`;
